import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import type { HeroSectionComponent } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { VisibilitySensor } from '@icontainers/design-system/dist/atoms/VisibilitySensor'

import { Wrapper } from './SlideInImage.styled'

export const SlideInImage = ({
    slideInImage,
    slideInImageAnimation,
}: Pick<HeroSectionComponent, 'slideInImage' | 'slideInImageAnimation'>): Nullable<JSX.Element> => {
    if (!slideInImage) return null

    return (
        <VisibilitySensor once partialVisibility="top">
            {({ isVisible }: { isVisible: boolean }) => (
                <Wrapper className={isVisible ? 'slideUp enter' : 'slideUp'} data-testid="slideInImage">
                    <Image image={slideInImage} imageAnimation={slideInImageAnimation} />
                </Wrapper>
            )}
        </VisibilitySensor>
    )
}
